import React, {useState} from 'react'
import SearchRecipes from './SearchRecipes'
import RecipeCategories from '../Recipe/RecipeCategories'
import AuthorsList from '../Author/AuthorsList'
import FilterRecipes from './FilterRecipes'

function DiscoverPage() {

    const [activeItem, setActiveItem] = useState("1")

    const currentPage = "discover";
    
    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab)
        }
    }

    return (
        <>
        <div className="container mt-4">
            <div className="row">
                <div className="col-4">
                    <button onClick={() => toggle("1")} className={activeItem === "1" ? "btn btn-sm btn-success btn-block active": "btn btn-sm btn-success btn-block"}>Søk oppskrifter</button>
                </div>
                <div className="col-4">
                    <button onClick={() => toggle("2")} className={activeItem === "2" ? "btn btn-sm btn-success active btn-block" : "btn btn-sm btn-success btn-block"}>Søk medlemmer</button>
                </div>
                <div className="col-4">
                    <button onClick={() => toggle("3")} className={activeItem === "3" ? "btn btn-sm btn-success active btn-block" : "btn btn-sm btn-success btn-block"}>Kategorier</button>
                </div>
            </div>
        </div>


        {activeItem === "1" && <FilterRecipes/>}
        {activeItem === "2" && <AuthorsList />}
        {activeItem === "3" && <RecipeCategories />}
        </>
    )
}
export default DiscoverPage